import Immutable from 'immutable';

const LearningResultRecord = Immutable.Record({
  skillResults: undefined,
  finishedPaperBasedHomework: undefined,
  totalPaperBasedHomework: undefined,
  finishedOnlineHomework: undefined,
  totalOnlineHomework: undefined,
  presentAttendence: undefined,
  totalAttendence: undefined,
});

class LearningResult extends LearningResultRecord { }

export default LearningResult;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/LearningResult/model.js